const breakpoints = () => {
  return 990
}

export { breakpoints }
